import { Box, Button, CssBaseline, Dialog, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useDarkMode } from "./hooks/useDarkMode";
import { useOidcConfigList } from "./hooks/useOidcConfigList";
import { useOidcConfigurationName } from "./hooks/useOidcConfigurationName";
import { useGlobalOptions } from "./hooks/useGlobalOptions";

export default function LoginPage() {
  const { darkModeEnabled } = useDarkMode();
  const { globalOptions } = useGlobalOptions();
  const { oidcConfigList } = useOidcConfigList();
  const { setOidcConfigurationName } = useOidcConfigurationName();

  const navigate = useNavigate();

  return (
    <Fragment>
      <CssBaseline />
      <Dialog open={true} maxWidth="md" fullWidth={true}>
        <Box
          sx={{ minHeight: "50vh" }}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{ gap: "1em" }}
          >
            <img
              alt="logo"
              src={
              globalOptions.whitelabel_loginlogo ?? (
                darkModeEnabled
                  ? globalOptions.whitelabel_darklogo ??
                    "/logo-dark.png"
                  : globalOptions.whitelabel_lightlogo ??
                    "/logo-light.png"
                  )
              }
              style={{ maxWidth: "60%" }}
            />
            <Typography variant="h5">Authenticate to Continue</Typography>
            {oidcConfigList.map((c) => (
              <Button
                variant="contained"
                onClick={() => {
                  setOidcConfigurationName(c.name);
                  navigate("/");
                }}
              >
                Continue with {c.name.toString()}
              </Button>
            ))}
          </Box>
        </Box>
      </Dialog>
    </Fragment>
  );
}
